/**
 * @since 1.1.0
 */
export interface TendencyData {
    /**
     * @since 1.1.3
     */
    code?: number;
    date?: string;
    value?: number;
}

/**
 * @since 1.1.0
 */
export interface Tendency {
    /**
     * @since 1.1.3
     */
    code?: number;
    name?: string;
    /**
     * @since 1.1.3
     */
    currency?: string;
    /**
     * @since 1.1.3
     */
    status?: TendencyStatus;
    /**
     * @since 1.1.3
     */
    type?: TendencyType;
    data?: TendencyData[];
    /**
     * @since 1.1.3
     */
    props?: { [name: string]: string };
}

/**
 * @since 1.1.3
 */
export enum TendencyStatus {
    Normal = 'normal',
    Removed = 'removed'
}

/**
 * @since 1.1.3
 */
export enum TendencyType {
    Product = 'product',
    Exchange = 'exchange'
}
